import { PencilIcon, TrashIcon } from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom'
import moment from 'moment'

const formatDateTime = value => {
	if (!value) return '-'
	return moment(value).isValid() ? moment(value).format('YYYY-MM-DD HH:mm') : '-'
}

const formatPostep = kampania => {
	const doneCount = kampania?.doneCount
	const placowkaCount = kampania?.placowkaCount

	if (doneCount == null && placowkaCount == null) return '-'

	return `${doneCount ?? 0}/${placowkaCount ?? 0}`
}

const getCreatedByName = kampania => {
	if (kampania?.createdByName) return kampania.createdByName
	if (typeof kampania?.createdById === 'object') {
		return kampania.createdById?.nazwa || kampania.createdById?.name || '-'
	}
	return '-'
}

export default function KampanieTableRow({ kampania, onEdit, onDelete }) {
	return (
		<tr className="hover:bg-gray-100">
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{kampania?._id ? (
					<Link
						to={`/komunikacja/kampanie/${kampania._id}/placowki`}
						className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">
						{kampania?.nazwa || '-'}
					</Link>
				) : (
					kampania?.nazwa || '-'
				)}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{formatDateTime(kampania?.created)}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{getCreatedByName(kampania)}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{formatPostep(kampania)}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap text-right">
				<div className="inline-flex items-center gap-2">
					<button
						type="button"
						onClick={() => onEdit(kampania)}
						className="inline-flex items-center gap-1 rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100">
						<PencilIcon className="h-4 w-4" />
						<span>Edytuj</span>
					</button>
					<button
						type="button"
						onClick={() => onDelete(kampania)}
						className="inline-flex items-center gap-1 rounded-md border border-red-100 bg-red-50 px-3 py-1.5 text-sm font-medium text-red-700 hover:bg-red-100">
						<TrashIcon className="h-4 w-4" />
						<span>Usuń</span>
					</button>
				</div>
			</td>
		</tr>
	)
}
